export const WAREHOUSE_MAIN_TYPE = 'main';
